export const endpoints = {
    salesforceOauth2: '/token',
        
    salesforceSave: '/salesforce/save',
    salesforceProviders: '/salesforce/providers',
    
    salesforceAccount: '/salesforce/account',
    salesforceGetPersonAccount: '/salesforce/person',
    salesforceOptin: '/salesforce/optin'
};